
import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import vSelect from "vue-select"
import Tags from "@/components/Fields/Tags.vue"
import AreaSelect from "@/components/Fields/AreaSelect.vue"
import FormGroup from "../Fields/FormGroup.vue"

import { Template, Area, Status, Severity, CaseDetails, TemplateDetails } from "@/types"

import TextAreaToggleExpand from "@/components/Fields/TextAreaToggleExpand.vue"
import { CurrentUser } from "@/types/user"

import api from "@/services/api"
const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect,
		"text-area-expand": TextAreaToggleExpand,
		"tags": Tags,
		"area-select": AreaSelect,
		"form-group": FormGroup
	}
})
export default class CaseDetailsHeader extends Vue {
	@Getter("getMe")
	public me!: CurrentUser;

	@caseStore.Getter("getStatuses") public statuses!: Status[];
	@caseStore.Getter("getSeverities") public severities!: Severity[];

	@caseStore.Getter("getCreatableCategories") public categories!: Template[] | null;
	@caseStore.State("areas") public areas!: Area[];

	@Prop()
	public currentCase!: CaseDetails

	@Prop()
	public template!: TemplateDetails

	@Prop({ default: false })
	public canEditCurrentCase!: boolean

	@Prop({ default: true })
	public titleTemplateEnabled!: boolean

	@Prop({ default: "Case" })
	public caseName!: string

	@Prop({ default: "Record" })
	public recordName!: string

	@Prop({ default: false })
	public showAreas!: boolean

	@Prop({ default: false })
	public showStatus!: boolean

	@Prop({ default: false })
	public showTags!: boolean

	@Prop({ default: false })
	public showSeverity!: boolean

	@Prop({ default: false })
	public preventTemplateChange!: boolean

	savingFields: { [key: string]: boolean } = {
		"summary": false
	}

	/**
	 * Map of built in fields user has lock on
	 */
	private get ownedLocks (): { [key: string]: boolean } {
		if (!this.currentCase || !this.currentCase.builtInFieldLocks) {
			return {}
		}

		return Object.keys(this.currentCase!.builtInFieldLocks!)
			.filter(key => this.currentCase!.builtInFieldLocks![key] && this.currentCase!.builtInFieldLocks![key]!.id === this.me!.id)
			.reduce((acc: { [key: string]: boolean }, key: string) => {
				acc[key] = true
				return acc
			}, {} as { [key: string]: boolean })
	}

	private onCaseChanged (): void {
		this.$emit("caseChanged")
	}

	private async onCaseCategoryChanged (templateId: string) {
		this.$emit("templateIdChanged", templateId)
	}

	public updateLocationsList () {
		this.$emit("caseChanged")
	}

	private fieldGotFocus (fieldId: string) {
		if (this.currentCase!.id && this.canEditCurrentCase) {
			api.selectCaseField(this.currentCase!.id, fieldId, true)
		}
	}

	private async fieldLostFocus (fieldId: string, newValue: string): Promise<void> {
		if (this.currentCase!.id && this.canEditCurrentCase) {
			try {
				this.savingFields[fieldId] = true
				await api.saveCaseProperty(this.currentCase!.id, fieldId, newValue)
			} finally {
				this.savingFields[fieldId] = false
			}
		}
	}
}
